import styled from 'styled-components';

export const StyledContactsPageContainer = styled.div`
  background: linear-gradient(
    50deg,
    rgb(93, 152, 219) 50%,
    rgb(186, 209, 234) 75%,
    rgb(93, 152, 219)
  );
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
